import {
  CHANGE_LOGIN_BUTTON_MESSAGE,
  CHANGE_LOGIN_ERROR_MESSAGE,
  HIDE_MODAL_PASSWORD,
  SHOW_PASSWORD_SET_SUCCESS
} from '../actions'

export default function loginReducer (state, action) {
  switch (action.type) {
    case CHANGE_LOGIN_BUTTON_MESSAGE:
      return {
        ...state,
        loginMessage: action.message
      }
    case CHANGE_LOGIN_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.message
      }
    case SHOW_PASSWORD_SET_SUCCESS:
      return {
        ...state,
        showPasswordSetSuccess: true,
        showModalPassword: true
      }
    case HIDE_MODAL_PASSWORD:
      return {
        ...state,
        showModalPassword: false
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/loginReducer.js